import {ValueObject} from '@s-ui/domain'

export class LastDetailsViewedItemValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.id
   *
   */
}
